module.exports = __webpack_public_path__ + "img/avatar2.4c1a7d9f.png";